export const translations = {
  'nav.how': { en: 'How it works', th: 'วิธีใช้งาน' },
  'nav.performers': { en: 'For performers', th: 'สำหรับศิลปิน' },
  'nav.organisers': { en: 'For organisers', th: 'สำหรับผู้จัดงาน' },
  'nav.pricing': { en: 'Pricing', th: 'ราคา' },
  'nav.signIn': { en: 'Sign in', th: 'เข้าสู่ระบบ' },
  'nav.getStarted': { en: 'Get started', th: 'เริ่มต้นใช้งาน' },
  'hero.line1': { en: 'Find your crowd.', th: 'หาผู้ชมของคุณ' },
  'hero.line2': { en: 'Fill your stage.', th: 'เติมเวทีให้เต็ม' },
  'hero.lead': {
    en: 'Encorza matches singers and bands with the events that want them. Swipe, chat and book — with every payment protected.',
    th: 'Encorza จับคู่นักร้องและวงดนตรีกับงานที่กำลังมองหาพวกเขา ปัด แชท แล้วจองได้เลย พร้อมระบบคุ้มครองการชำระเงินทุกครั้ง',
  },
  'hero.ctaPerform': { en: 'I perform — get started', th: 'ฉันเป็นศิลปิน — เริ่มเลย' },
  'hero.ctaOrganise': { en: 'I’m organising an event', th: 'ฉันกำลังจัดงาน' },
  'demo.title': { en: 'Try it. Swipe right twice.', th: 'ลองเลย ปัดขวาสองครั้ง' },
  'how.title': { en: 'Two sides. One stage.', th: 'สองฝั่ง หนึ่งเวที' },
  'how.performers': { en: 'For singers & bands', th: 'สำหรับนักร้องและวงดนตรี' },
  'how.organisers': { en: 'For event organisers', th: 'สำหรับผู้จัดงาน' },
  'break.title': { en: 'Every gig starts with a yes.', th: 'ทุกงานเริ่มจากคำว่า “ใช่”' },
  'trust.title': { en: 'Built so both sides can trust the booking.', th: 'ออกแบบให้ทั้งสองฝ่ายมั่นใจในทุกการจอง' },
  'pricing.title': { en: 'Free to join. Pay when it’s worth it.', th: 'สมัครฟรี จ่ายเมื่อคุ้มค่า' },
  'cta.title': { en: 'Your next gig is a swipe away.', th: 'งานต่อไปของคุณ ห่างแค่ปัดเดียว' },
  'cta.body': { en: 'Free to join on both sides. Set up in a few minutes.', th: 'สมัครฟรีทั้งสองฝั่ง ตั้งค่าเสร็จในไม่กี่นาที' },
  'cta.perform': { en: 'I perform', th: 'ฉันเป็นศิลปิน' },
  'cta.organise': { en: 'I organise events', th: 'ฉันจัดงาน' },
  'role.title': { en: 'How will you use Encorza?', th: 'คุณจะใช้ Encorza แบบไหน?' },
  'role.subtitle': { en: 'You’ll get an app tailored to your side of the stage.', th: 'คุณจะได้แอปที่ออกแบบมาสำหรับฝั่งของคุณโดยเฉพาะ' },
  'role.perform.body': { en: 'Solo singers, duos and bands looking for gigs.', th: 'นักร้องเดี่ยว ดูโอ และวงดนตรีที่กำลังหางาน' },
  'role.organise.body': { en: 'Weddings, venues, festivals, parties and corporate nights.', th: 'งานแต่ง ร้าน เฟสติวัล ปาร์ตี้ และงานบริษัท' },
  'role.already': { en: 'Already on Encorza?', th: 'มีบัญชี Encorza แล้ว?' },
  'tab.discover': { en: 'Discover', th: 'ค้นหา' },
  'tab.gigs': { en: 'Gigs', th: 'งาน' },
  'tab.messages': { en: 'Messages', th: 'ข้อความ' },
  'tab.profile': { en: 'Profile', th: 'โปรไฟล์' },
  'tab.events': { en: 'Events', th: 'อีเวนต์' },
  'tab.review': { en: 'Review', th: 'คัดเลือก' },
  'tab.account': { en: 'Account', th: 'บัญชี' },
  'common.continue': { en: 'Continue', th: 'ต่อไป' },
  'common.skip': { en: 'Skip', th: 'ข้าม' },
  'settings.language': { en: 'Language', th: 'ภาษา' },
  'settings.languageHint': { en: 'Interface language. Event and profile content stays as written.', th: 'ภาษาของแอป เนื้อหาอีเวนต์และโปรไฟล์จะแสดงตามที่เขียนไว้' },
} as const;

export type TranslationKey = keyof typeof translations;
